import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import ReactPlayer from "react-player";
import { useParams } from "react-router-dom";
import { serverInfo } from "../../../../../../App";
import ContentLoader from "../../../../../../Screen/ContentLoader";
import NodataAvailable from "../../../../../Common/NodataAvailable";
import "../Content/FanStar.css";
const FanMedia = () => {

  const { imageCdnUrl,videoCdnUrl } = useContext(serverInfo);

  const [loading, setLoading] = useState(true);
  const { slug } = useParams();
  const [fanMedia, setFanMedia] = useState([]);
  const [fanMediaVideo, setFanMediaVideo] = useState([]);

  useEffect(() => {
    axios.get(`/api/user/fan/group/post/show/${slug}`).then((res) => {
      setLoading(false);
      if (res.status === 200) {
        setFanMedia(res.data.fanMedia);
        setFanMediaVideo(res.data.fanVideo);
      }
    });
  }, [slug]);

  return (
    <>
      {" "}
      {loading ? (
        <ContentLoader />
      ) : (
        <>
          {fanMedia.length === 0 ? (
            <NodataAvailable />
          ) : (
            <>
              <div className="MediaBG mt-3">
                <div className="row p-3">
                  {fanMedia.map((media, i) => (
                    <div className="col-sm-6 col-md-4 col-lg-3 mb-3">
                      {" "}
                      <div className="card-media card  p-2">
                        <img
                          src={imageCdnUrl + media.image}
                          className="img-fluid "
                          style={{ height: "120px" }}
                          alt=""
                        />
                      </div>
                    </div>
                  ))}
                  {fanMediaVideo.map((media, i) => (
                    <div className="col-sm-6 col-md-4 col-lg-3 mb-3">
                      {" "}
                      <div className="card-media card  p-2">
                        <video
                          width="100%"
                          className="img-fluid "
                          controls
                          style={{ height: "120px" }}
                        >
                          <source
                            src={videoCdnUrl + media.video}
                          />
                        </video>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </>
          )}
        </>
      )}
    </>
  );
};

export default FanMedia;
